import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const QUERY = graphql(`
  mutation createTopBanner($companyId: ID!, $input: CreateTopBannerInput!) {
    createTopBanner(companyId: $companyId, input: $input) {
      ...TopBannerItem
    }
  }
`);

export function useCreateTopBanners() {
  return useMutation(QUERY, {
    refetchQueries: ['topBanners', 'topBanner'],
  });
}
